// 데스크톱 웹은 GPS가 없고 브라우저 표준 측위(navigator.geolocation)가
// POSITION_UNAVAILABLE로 실패하는 경우가 많다. 이때 IP 기반으로 대략적인
// 좌표(도시/구 단위)를 받아 폴백한다. 정확도는 낮지만 값은 항상 확보된다.
export async function fetchIpLocation(): Promise<{
  latitude: number;
  longitude: number;
} | null> {
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (!res.ok) return null;

    const data = (await res.json()) as {
      latitude?: number | string;
      longitude?: number | string;
    };

    const latitude = Number(data.latitude);
    const longitude = Number(data.longitude);

    if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
      return { latitude, longitude };
    }
    return null;
  } catch {
    return null;
  }
}
